import React from 'react'

const Travelandtourism = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Find the words form the text which mean the following.</p>
        <p>a. became fuller and softer by shaking - fluffed</p>
        <p>b. sound mental health - sanity</p>
        <p>c. consisting of or easily breaking into small pieces - crumbly</p>
        <p>d. neither very hot nor very cold - temperate</p>
        <p>e. land that does not have enough water to support the growth of plants - arid region</p>
        <p>f. only slightly warm - lukewarm</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Find the meanings of the following words in an English dicitonary, write their word classes and use them in your own sentences.</p>
        <p>a. hazy (adjective): not clear because of haze, fog, or confusion</p>
        <p>The mountain looked beautiful even though it was hazy in the morning light.</p>
        <br/>
        <p>b. frontier (Noun): a border between two countries or the edge of a settled area</p>
        <p>Scientists are constantly pushing the frontier of medical research to find new cures.</p>
        <br/>
        <p>c. lush (adjective) :full of healthy green plants; rich and beautiful.</p>
        <p>The garden looked lush after the rain.</p>
        <br/>
        <p>d. flipflops (noun) :light, open sandals typically worn in warm weather</p>
        <p>I wore my flip-flops to the beach.</p>
        <br/>
        <p>e. altitude (noun) : the height of something above sea level or ground level.</p>
        <p>The airplane reached an altitude of 30,000 feet during the flight.</p>
        <br/>
        <p>f. fatal (adjective) :causing death or leading to disaster</p>
        <p>The car accident was fatal, and sadly, the driver did not survive.</p>
        <br/>
        <p>g. magnificent (adjective) :very beautiful, impressive, or grand.</p>
        <p>The view from the mountain was absolutely magnificent.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. make a list of the Nepali words used in the text and write their English equivalents.</p>
        <p>bideshi : foreign</p>
        <p>Tatopani : hot water</p>
        <p>raksi : wine</p>
        <p>bahini : younger sister</p>
        <p>mathi : up/above</p>
        <p>tala : down/ below</p>
        <p>sutne : sleep</p>
        <p>panipuri : water balls</p>
        <p>pani : water</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. How did the author feel when she saw a colourful rooster in the western Himalayas?</p>
        <p>= The author felt surprised and amused when she saw a colorful rooster in the western Himalayas. It looked at her for a second and even seemed to wink, which made the moment funny and unforgettable for her.</p>

        <p className='question'>b. How does she describe the houses on the trails of western Nepal?</p>
        <p>= She describes the houses as being built from stones, placed under big rocks near rivers. Even though they looked like they could fall down anytime, the people living there seemed happy and comfortable.</p>

        <p className='question'>c. What does she mean when she says "I walked towards a village15 kilometres further as the crow flies?"</p>
        <p>= She means that the village was 15 kilometers away if you measure the straight-line distance, not the actual walking path, which could be much longer because of the mountains and trails.</p>

        <p className='question'>d. Describe the village Thankur in brief.</p>
        <p>= Thankur is a small village with only two houses. It lies in a dry and rocky area with not many people around. However, colorful birds like the Himalayan monal live there, which makes it special.</p>

        <p className='question'>e. What happened when she reached Jumla and how was she relieved?</p>
        <p>= When she reached Jumla, she became sick with a stomach problem and a virus. Luckily, after taking some medicine and eating pani puri, she started to feel better and was relieved.</p>

        <p className='question'>f. How does the author describe the bucket water in Khali Lagna?</p>
        <p>= In Khali Lagna, the water in the bucket had a frozen layer on top. When she broke the ice, she was surprised and happy to feel that the water underneath was warm.</p>

        <p className='question'>g. How was Rara Lake on the day she reached there?</p>
        <p>= When she reached Rara Lake, its water was shining beautifully with a deep blue color. It looked peaceful and magical.</p>
      </div>
      <hr/>
      <div>
        <h3>Critical Thinking</h3>
        <p className='question'>a. It is said that travelling a place equals to reading three books. Do you agree? Why?</p>
        <p>= Yes, I agree with the saying that travelling a place is like reading three books. When we travel, we get to see new places, meet different people, and learn about new cultures. This gives us knowledge that we cannot get just by reading books. For example, reading about mountains is not the same as actually climbing one and feeling the cool wind. We remember the experience better when we see things with our own eyes.
</p><p>
Travelling also teaches us life lessons. We learn to manage time, solve problems, and handle unexpected things like delays or getting lost. This helps us become more confident and independent. It also helps us see how big and beautiful the world is and makes us feel connected with others around the world.
</p><p>
In short, travelling is fun, exciting, and full of learning. That's why I believe travelling really is like reading many books at once and even better!</p>
      </div>
      <hr/>
      <div >
        <p className='question'>b. The author spent five-week long walk along the western Himalayas. Do you think it was adventurous? Why?</p>
        <p>= Yes, I think the author's journey was really adventurous. Walking for five weeks in the high mountains of western Nepal is not easy. She walked through forests, snowy areas, rivers, and even very dry places. She had to sleep in cold places and carry her own things. That takes a lot of courage and energy.
</p><p>
She also went to places where not many people travel. Some of the villages she visited were far away from cities and had very simple lifestyles. She had to deal with problems like getting sick and walking in tough weather, but she didn't give up. I think her trip was full of new experiences, challenges, and excitement. That's why I believe her journey was truly adventurous.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>A. Write a travelogue of your recent visit to a natural/religious place in about 300 words.</p>
        <strong>A Visit to Muktinath - A Journey of Peace and Beauty</strong>
        <p>Last month, I had the chance to visit Muktinath, a famous religious and natural place in Mustang district of Nepal. It was one of the most beautiful and peaceful journeys I've ever taken. We went by bus from Pokhara to Jomsom, and from there, we took a jeep to Muktinath.
</p><p>
The road was full of adventure. There were big hills, rivers, and snow-covered mountains all around us. The air was fresh, and the sky was so clear and blue. I felt like I was in a painting. As we reached Muktinath, I saw many people from different parts of Nepal and India coming to visit the temple.
</p><p>
Muktinath is a holy place for both Hindus and Buddhists. There is a big temple of Lord Vishnu and 108 water taps outside the temple. People believe that if you take a bath in all 108 taps, your sins will be washed away. The water was freezing cold, but many people were still bathing with full faith.
</p><p>
There was also a natural fire called "Jwala Mai" that never stops burning. It is believed to be a symbol of the divine. I felt very peaceful while walking around the temple and looking at the beautiful mountains behind it.
</p><p>
The local people were kind and welcoming. I tried some local food like buckwheat roti and apple jam, which were very tasty.
</p><p>
This journey gave me not only fun and adventure, but also peace and a new respect for nature and culture. I will always remember my trip to Muktinath and hope to go back again someday.

</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Write an essay in about 500 words on 'Importance of Tourism in Nepal'.</p>
        <strong>Importance of Tourism in Nepal</strong>
        <p>Nepal is a beautiful country full of mountains, rivers, forests, temples, and cultures. Many people from different countries come to visit Nepal every year. This is called tourism. Tourism plays a very important role in Nepal, and it helps our country in many ways.
</p><p>
First of all, tourism helps in earning money for the country. Tourists spend money on hotels, food, transport, and buying souvenirs. This money helps the people who work in the tourism sector like guides, drivers, hotel owners, and even farmers who supply vegetables. It helps in reducing unemployment and improves the living standard of many Nepali people.
</p><p>
Secondly, tourism helps in promoting our culture and traditions. Nepal is rich in festivals, art, dances, and historical places. When foreigners visit Nepal, they get to learn about our customs, temples, and festivals like Dashain, Tihar, Buddha Jayanti, and many others. They also take our culture back to their countries and tell other people about Nepal.
</p><p>
Tourism also helps in building roads, hotels, and communication services in remote areas. When tourists go to places like Mustang, Dolpa, or Rara, the government and people start developing those places. This helps local people get better services and facilities.
</p><p>
Nepal is known for its natural beauty. Mount Everest, the highest peak in the world, lies in our country. Tourists come to trek in the Himalayas, visit lakes, national parks, and historical places like Lumbini, the birthplace of Lord Buddha. These natural and religious places make Nepal a dream destination for many.
</p><p>
However, we should also be careful. Too many tourists can harm the environment. They may throw plastic, cut trees, or disturb wildlife. So, we must promote eco-tourism where nature is protected and respected. We should also behave kindly and honestly with tourists so that they have good experiences and tell others to visit Nepal.
</p><p>
In conclusion, tourism is very important for Nepal. It helps in economic development, job creation, cultural exchange, and infrastructure growth. If we protect our natural beauty and treat tourists well, Nepal can become one of the best tourist destinations in the world. We all should help in making Nepal clean, safe, and welcoming for tourists.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Complete these sentences using the verbs given in the brackets.</p>
        <p>a. Letters <strong>are delivered</strong> by the postman every day. (deliver)</p>
        <p>b. This bag <strong>was found</strong> in the bus yesterday. (find)</p>
        <p>c. The gate <strong>is locked</strong> at 7:00 pm every evening. (lock)</p>
        <p>d. I <strong>was invited</strong> to the party last week. (invite)</p>
        <p>e. The telephone <strong>was invented</strong> by Graham Bell. (invent)</p>
        <p>f. Muna Madan <strong>was written</strong> by Devkota. (write)</p>
        <p>g. How much money <strong>was stolen</strong> in the robbery? (steal)</p>
        <p>h. Do you know cheese <strong>is made</strong> from milk? (make)</p>
        <p>i. I was born in Kathmandu, but <strong>was grown</strong> in Dhangadhi. (grow)</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Change the following sentences into passive.</p>
        <p>a. I didn't fix the problem.</p>
        <p>= The problem wasn't fixed by me.</p>
        <br/>
        <p>b. Police protect the town.</p>
        <p>= The town is protected by the police.</p>
        <br/>
        <p>c. John's mother raised him in a small town.</p>
        <p>= He was raised in a small town by John's mother.</p>
        <br/>
        <p>d. Someone painted the building last year.</p>
        <p>= The building was painted last year.</p>
        <br/>
        <p>e. Alexander Fleming discovered penicillin in 1928.</p>
        <p>= Penicillin was discovered in 1928 by Alexander Fleming.</p>
        <br/>
        <p>f. Some students study grammar on the Internet.</p>
        <p>= Grammar is studied on the Internet by some students.</p>
        <br/>
        <p>g. Someone had broken the window by 3:00 p.m.</p>
        <p>= The window had been broken by 3:00 p.m.</p>
        <br/>
        <p>h. A strange man was watching us.</p>
        <p>= We were being watched by a strange man.</p>
        <br/>
        <p>i. Tokyo will hold the Olympics in 2020.</p>
        <p>= The Olympics will be held in 2020 by Tokyo.</p>
        <br/>
        <p>j. We are working on the report right now.</p>
        <p>= The report is being worked on right now by us.</p>
        <br/>
        <p>k. My manager has told him to arrive earlier.</p>
        <p>= He has been told to arrive earlier by my manager.</p>
        <br/>
        <p>l. They could not have made the mistake.</p>
        <p>= The mistake could not have been made by them.</p>
        <br/>
        <p>m. I hope they are going to hire me soon.</p>
        <p>= I hope I am going to be hired soon by them.</p>
        <br/>
        <p>n. I don't like people staring at me.</p>
        <p>= I don't like being stared at.</p>
        <br/>
        <p>o. She likes people waving at her.</p>
        <p>= She likes being waved at.</p>
        <br/>
        <p>p. Who told you the story?</p>
        <p>= By whom were you told the story? </p>
        <br/>
        <p>q. Is he repairing the bicycle?</p>
        <p>= Is the bicycle being repaired by him?</p>
      </div>
    </div>
  )
}

export default Travelandtourism
